import React, { useEffect, useState } from 'react';
import 'react-data-grid/lib/styles.css';
import { Card, CardBody, Col, Container, FormGroup, Row } from 'reactstrap';
import useAuth from '../../../hooks/useAuth';
import useFilter from '../../../hooks/useFilter';

export default function DetailedCompletionsViewOptions() {
    const { filter, setFilter } = useFilter() as any;
    const auth = useAuth();
    const [recordGrouping, setRecordGrouping] = useState<boolean>(true);

    useEffect(() => {
        setRecordGrouping((filter?.recordGrouping ?? true));
    }, []);

    const onChange = (value: boolean) => {
        filter.recordGrouping = value;
        setFilter(filter);
        setRecordGrouping(value);
    };

    const isKy = auth?.auth.isKy;
    const isCa = auth?.auth.isCa;
    const isWa = auth?.auth.isWa;

    const detailData = [
        { id: "1", value: "Full Name" },
        { id: "2", value: "Course/Activity" },
        { id: "3", value: "Type" },
        { id: "4", value: "Category" },
        { id: "5", value: "Training Hours" },
        { id: "6", value: "Completion Date" },
        { id: "7", value: "Start Time" },
        { id: "8", value: "End Time" },
        { id: "9", value: "ISO Code" },
        { id: "10", value: "Kentucky Code" },
        { id: "11", value: "CAL-JAC Code" },
        { id: "12", value: "WSRB Category" },
        { id: "13", value: "Other Training Codes" },
        { id: "14", value: "Score" },
        { id: "15", value: "Location" },
        { id: "16", value: "Description" },
        { id: "17", value: "Internal Instructors" },
        { id: "18", value: "External Instructors" },
    ]

    if (!isKy) {
        const kyIdx = detailData.findIndex(obj => obj.value === "Kentucky Code");
        detailData.splice(kyIdx, 1);
    }
    if (!isCa) {
        const caIdx = detailData.findIndex(obj => obj.value === "CAL-JAC Code");
        detailData.splice(caIdx, 1);
    }
    if (!isWa) {
        const waIdx = detailData.findIndex(obj => obj.value === "WSRB Category");
        detailData.splice(waIdx, 1);
    }

    const userData = [
        { id: "19", value: "Department" },
        { id: "20", value: "Personnel ID" },
        { id: "21", value: "Rank" },
        { id: "22", value: "Shift" },
        { id: "23", value: "Station" },
        { id: "24", value: "Division" },
        { id: "25", value: "Battalion" },
        { id: "26", value: "Company" },
        { id: "27", value: "Platoon" },
        { id: "28", value: "Bureau" },
        { id: "29", value: "EMS Certification" },
    ];

    return (
        <Container>
            <h1>Report Fields</h1>
            <FormGroup>
                <Card>
                    <CardBody>
                        <Row>
                            <Col xs="6">
                                <div>Record Grouping</div>
                            </Col>
                            <Col xs="6">
                                <div>
                                    <input className='radio-margin' type='radio' name='checklistsRadio' onChange={() => onChange(true)} checked={recordGrouping === true} /> Group By Department and User
                                    <br/>
                                    <input className='radio-margin' type='radio' name='checklistsRadio' onChange={() => onChange(false)} checked={recordGrouping === false} /> Ungrouped
                                    
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </FormGroup>
            <FormGroup>
                <Card>
                    <CardBody>
                        <Row>
                            <Col xs="6">
                                <div>Detail Fields</div>
                            </Col>
                            <Col xs="6">
                                {detailData.map((item, index) => {
                                    return (
                                        <div key={item.id} className="checkbox-container">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="options"
                                                    value={item.value}
                                                    defaultChecked={true}
                                                    disabled={true}
                                                />
                                                &nbsp;{item.value}
                                            </label>
                                        </div>
                                    );
                                })}
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </FormGroup>
            <FormGroup>
                <Card>
                    <CardBody>
                        <Row>
                            <Col xs="6">
                                <div>User Fields</div>
                            </Col>
                            <Col xs="6">
                                {userData.map((item, index) => {
                                    return (
                                        <div key={item.id} className="checkbox-container">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="options"
                                                    value={item.value}
                                                    defaultChecked={true}
                                                    disabled={true}
                                                />
                                                &nbsp;{item.value}
                                            </label>
                                        </div>
                                    );
                                })}
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </FormGroup>
        </Container>
    );
}